export const regularExpressions = {
    UsaRegex: / USA$|, USA$/gmi,                   //Regular Expression that has the last occurrence of the word "USA" or ", USA" 
}